import request from '../request'
import i18n from '../../main'
// params为query data为body
export function getLanguage(params) {
    return request({
        url: '/pages/getLanguage',
        method: 'get',
        params
      })
 }

// 查询产品
export function selectProduct(params) {
    params["languageType"]=i18n.locale
  return request({
    url: '/program/selectProduct',
    method: 'get',
    params
  })
}
// 获取单个产品详情图
export function getDetails(params) {
    params["languageType"]=i18n.locale
    return request({
        url: '/program/getDetails',
        method: 'get',
        params
    })
}
// 素材列表
export function selectMaterial(params) {
    params["languageType"]=i18n.locale
  return request({
    url: '/MaterialModule/selectMaterial',
    method: 'get',
    params
  })
}
// 查看素材
export function getMaterial(params) {
    params["languageType"]=i18n.locale
    return request({
        url: '/MaterialModule/getMaterial',
        method: 'get',
        params
    })
}
export function selectVideoList(params){
    params["languageType"]=i18n.locale
    return request({
        url:'/video/selectVideoList',
        method: 'get',
        params
    })
}
// 下载素材
export function downloadMaterial(params) {
    params["languageType"]=i18n.locale
    return request({
        url: '/MaterialModule/downloadMaterial',
        method: 'get',
        params
    })
}
// 显示全部新闻
export function selectJournalism(params) {
    params["languageType"]=i18n.locale
    return request({
        url: '/journalism/selectJournalism',
        method: 'get',
        params
    })
}
// 获取单个新闻
export function getJournalism(params) {
    params["languageType"]=i18n.locale
    return request({
        url: '/journalism/getJournalism',
        method: 'get',
        params
    })
}
// 专利技术列表
export function selectPatent(params) {
    params["languageType"]=i18n.locale
    return request({
        url: '/patents/selectPatent',
        method: 'get',
        params
    })
}
// 荣誉资质列表
export function selectHonor(params) {
    params["languageType"]=i18n.locale
    return request({
        url: '/certificates/selectHonor',
        method: 'get',
        params
    })
}
// 添加留言
export function addMessage(data) {
    return request({
        url: '/feedback/submit',
        method: 'post',
        params:{languageType :i18n.locale},
        data
    })
}
